// Configurazioni principali della ruota della fortuna
export const WHEEL_SETTINGS = {
    // Impostazioni animazione
    SPIN_DURATION: 8000, // Durata in millisecondi
    SPIN_ROTATIONS: 8, // Numero di giri completi

    // Impostazioni grafiche
    WHEEL_RADIUS: 250,
    WHEEL_CENTER_X: 250,
    WHEEL_CENTER_Y: 250,
    TEXT_RADIUS_RATIO: 0.7, // Posizione del testo (70% del raggio)

    // Colori predefiniti
    COLORS: {
        WINNING: "#669966",
        LOSING: "#339966",
        PRIMARY: "#99ff66",
    },
};

// Configurazione dei segmenti (personalizzabile)
export const DEFAULT_SEGMENTS = [
    {
        text: "HAI VINTO!",
        icon: `<img src="/images/video-consulto-white.svg" alt="Corallo" width="112" height="112" class="display-2" loading="lazy" decoding="async" />`,
        color: WHEEL_SETTINGS.COLORS.WINNING,
        isWinning: true,
    },
    {
        text: "NON HAI<br> VINTO",
        icon: `<i class="fa-light fa-face-frown display-2"></i>`,
        color: WHEEL_SETTINGS.COLORS.LOSING,
        isWinning: false,
    },
    {
        text: "HAI VINTO!",
        icon: `<img src="/images/video-consulto-white.svg" alt="Corallo" width="112" height="112" class="display-2"" loading="lazy" decoding="async" />`,
        color: WHEEL_SETTINGS.COLORS.WINNING,
        isWinning: true,
    },
    {
        text: "NON HAI<br> VINTO",
        icon: `<i class="fa-light fa-face-frown display-2"></i>`,
        color: WHEEL_SETTINGS.COLORS.LOSING,
        isWinning: false,
    },
    {
        text: "HAI VINTO!",
        icon: `<img src="/images/video-consulto-white.svg" alt="Corallo" width="112" height="112" class="display-2" loading="lazy" decoding="async" />`,
        color: WHEEL_SETTINGS.COLORS.WINNING,
        isWinning: true,
    },
    {
        text: "NON HAI<br> VINTO",
        icon: `<i class="fa-light fa-face-frown display-2"></i>`,
        color: WHEEL_SETTINGS.COLORS.LOSING,
        isWinning: false,
    },
    {
        text: "HAI VINTO!",
        icon: `<img src="/images/video-consulto-white.svg" alt="Corallo" width="112" height="112" class="display-2" loading="lazy" decoding="async" />`,
        color: WHEEL_SETTINGS.COLORS.WINNING,
        isWinning: true,
    },
    {
        text: "NON HAI<br> VINTO",
        icon: `<i class="fa-light fa-face-frown display-2"></i>`,
        color: WHEEL_SETTINGS.COLORS.LOSING,
        isWinning: false,
    },
];

// Funzioni di utilità per la configurazione
export const ConfigUtils = {
    /**
     * Crea una configurazione personalizzata con un numero specifico di segmenti
     * @param {number} segmentCount - Numero di segmenti desiderati
     * @param {Array} customSegments - Array di segmenti personalizzati (opzionale)
     * @returns {Object} Configurazione della ruota
     */
    createCustomConfig(segmentCount = 8, customSegments = null) {
        const segments = customSegments || this.generateDefaultSegments(segmentCount);

        return {
            segments: segments.slice(0, segmentCount),
            settings: { ...WHEEL_SETTINGS },
        };
    },

    /**
     * Genera segmenti predefiniti per un numero specifico
     * @param {number} count - Numero di segmenti
     * @returns {Array} Array di segmenti
     */
    generateDefaultSegments(count) {
        const baseSegments = [...DEFAULT_SEGMENTS];
        const result = [];

        for (let i = 0; i < count; i++) {
            result.push(baseSegments[i % baseSegments.length]);
        }

        return result;
    },

    /**
     * Crea segmenti con colori alternati
     * @param {Array} texts - Array di testi per i segmenti
     * @param {Array} icons - Array di icone per i segmenti
     * @param {boolean} alternateWinning - Se alternare vincenti/perdenti
     * @returns {Array} Array di segmenti configurati
     */
    createAlternatingSegments(texts, icons, alternateWinning = true) {
        return texts.map((text, index) => ({
            text: text,
            icon: icons[index] || "🎯",
            color: alternateWinning && index % 2 === 0 ? WHEEL_SETTINGS.COLORS.WINNING : WHEEL_SETTINGS.COLORS.LOSING,
            isWinning: alternateWinning ? index % 2 === 0 : true,
        }));
    },

    /**
     * Valida la configurazione dei segmenti
     * @param {Array} segments - Array di segmenti da validare
     * @returns {boolean} True se la configurazione è valida
     */
    validateSegments(segments) {
        if (!Array.isArray(segments) || segments.length === 0) {
            console.error("I segmenti devono essere un array non vuoto");
            return false;
        }

        return segments.every((segment, index) => {
            const required = ["text", "icon", "color", "isWinning"];
            const missing = required.filter((prop) => !(prop in segment));

            if (missing.length > 0) {
                console.error(`Segmento ${index}: proprietà mancanti: ${missing.join(", ")}`);
                return false;
            }

            return true;
        });
    },
};
